import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createRouter, createWebHistory } from 'vue-router'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'
import App from './App.vue'
import './style.css'
import './style-mobile.css'

// 导入路由配置和守卫
import { routes } from './router'
import { setupRouterGuards } from './router/guards'

// 创建路由实例
const router = createRouter({
  history: createWebHistory(),
  routes,
})

// 创建 Pinia 实例
const pinia = createPinia()

// 创建 Vue 应用
const app = createApp(App)

// 使用插件
app.use(pinia)
app.use(router)
app.use(Toast, {
  position: 'top-right',
  timeout: 3000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: 'button',
  icon: true,
  rtl: false,
})

// 设置路由守卫
setupRouterGuards(router)

// 在挂载应用之前，等待路由就绪
router.isReady().then(() => {
  // 挂载应用
  app.mount('#app')
})
